var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("path",{"d":"M1.268 11h19.106M11 1.268v19.106"})));
}

Plus.defaultProps = {"viewBox":"0 0 22 22","width":"22","height":"22"};

module.exports = Plus;

Plus.default = Plus;
